import React, { useState } from "react";

// Higher-Order Component to add cancel reservation popup functionality
const CancelReservationPopupHOC = (Component: any) =>
  function Comp(props: any) {
    // State to manage the visibility of the cancel reservation popup
    const [cancelReservationPopup, setCancelReservationPopup] =
      useState<boolean>(false);

    // Toggles the visibility of the cancel reservation popup
    const cancelReservationToggleHandler = () => {
      setCancelReservationPopup(!cancelReservationPopup);
    };

    // Passes the popup state and toggle handler as props to the wrapped component
    return (
      <Component
        cancelReservationPopup={cancelReservationPopup}
        cancelReservationToggleHandler={cancelReservationToggleHandler}
        {...props}
      />
    );
  };

export default CancelReservationPopupHOC;
